module.exports = __webpack_public_path__ + "6c1fe203991074907c23c5a6a73f9268.png";